var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95345 15C7.38489 15.7343 9.03152 15.9332 10.5966 15.5608C12.1617 15.1885 13.5424 14.2694 14.4898 12.9691C15.4372 11.6689 15.889 10.073 15.7639 8.46912C15.6388 6.86521 14.9449 5.35873 13.8073 4.22115C12.6697 3.08357 11.1632 2.38969 9.55933 2.26457C7.95542 2.13944 6.35956 2.59129 5.05932 3.53869C3.75908 4.48609 2.83997 5.86674 2.46762 7.43184C2.09527 8.99694 2.29416 10.6436 3.02845 12.075L1.82849 16.2L5.95345 15Z",
    stroke: "#929397",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84595 6.75C7.02228 6.24875 7.37031 5.82608 7.82841 5.55685C8.28652 5.28762 8.82512 5.1892 9.34883 5.27903C9.87254 5.36886 10.3476 5.64114 10.6898 6.04765C11.032 6.45415 11.2192 6.96864 11.2184 7.5C11.2184 9 8.96845 9.75 8.96845 9.75",
    stroke: "#929397",
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02844 12.75H9.03678",
    stroke: "#929397",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.326552d1284287ff6a254da002b4401d.svg";
export { ForwardRef as ReactComponent };